import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home.js";
import About from "./pages/About/About.js";
import UserDashboard from "./pages/UserDashboard/UserDashboard.js";
import Navbar from "./components/Navbar/Navbar.js";
import Journals from "./pages/Journals/Journals.js";
import Guide from "./pages/Guide/Guide.js";
import Footer from "./components/Footer/Footer.js";
import styles from "./App.module.css";

const App = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("/api/session", {
          credentials: "include",
        });

        if (!res.ok) {
          console.warn("Session check failed:", res.status);
          return;
        }

        const data = await res.json();

        if (data.validSession) {
          setLoggedIn(true);
        }
      } catch (error) {
        console.error("Error checking session:", error);
      }
    })();
  }, []);

  const routes = [
    {
      path: "/",
      name: "Home",
      element: <Home />,
    },
    {
      path: "/guide",
      name: "Guide",
      element: <Guide />,
    },
    {
      path: "/journals",
      name: "Journal Stats",
      element: <Journals />,
    },
    {
      path: "/dashboard",
      name: "My Stats",
      element: (
        <UserDashboard isLoggedIn={loggedIn} setLoggedIn={setLoggedIn} />
      ),
    },
    {
      path: "/about",
      name: "About",
      element: <About />,
    },
  ];
  return (
    <div className={styles.appContainer}>
      <Navbar
        links={routes.map((route) => {
          return { path: route.path, name: route.name };
        })}
        isLoggedIn={loggedIn}
        setLoggedIn={setLoggedIn}
      />
      <div className={styles.contentWrap}>
        <Routes>
          {routes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
      </div>
      <Footer />
    </div>
  );
};

export default App;
